// Cache identities for the `dictation/logs` family (ARCFE-1043 · C).
//
// Frozen VERBATIM from their single pre-move definition site. That file was
// deleted with the dictationLogs root, so this module is the only declaration.
// There is therefore exactly ONE declaration per
// identity, and `migration:check`'s `key-single-site` guard fails the build if
// either literal is ever re-declared under `src/**`.
//
// WHY ONE MODULE FOR HISTORY, STATS AND DELETE — the two-family partition
// ruling (the program owner, 2026-08-13) executed rather than restated. The
// child change's `design.md` D2 proposed four families: `history`, `stats`,
// `delete`, `preferences`. Measured at HEAD, the first three do not separate:
//
//   * `useDictationLogs` DECLARES the list cache at
//     `[DICTATION_LOGS_INFINITE_KEY, trimmedSearch, fromTime, toTime]`;
//   * `useDeferredDeleteDictationLog` WRITES it — `cancelQueries`,
//     `getQueriesData`, then per-variant `setQueryData` splicing, plus a
//     position-accurate re-insert on undo/rollback;
//   * `useMutationDeleteDictationLogs` WRITES it the same way in bulk, holding
//     a snapshot of every variant for its error rollback.
//
// One identity, three surfaces, all optimistic. Splitting the families would
// force either a second declaration site for `'dictation-logs-infinite'`
// (which the frozen-key law forbids) or a package-to-package import created
// solely to name another family's key. That is the same reasoning that made
// `evidence/library` one family at ARCFE-1049.
//
// FALSIFIER, recorded so the ruling can be overturned by measurement rather
// than by opinion: if the delete hooks' optimistic splice is ever replaced by
// a plain `invalidateQueries`, history and delete decouple and the four-family
// design becomes clean again.
//
// Stats is a WEAKER member of this family and is recorded as such: no delete
// path touches `DICTATION_LOGS_STATS_KEY`, so it is already cache-independent.
// It is grouped here because it is the same page, the same api block
// (`getDictationStats` sits in the same t11nClient tail as the other four log
// fns) and therefore the same D1 blocker. Splitting it out later is cheap.

/**
 * The paginated/searched dictation history list. The full tuple carries three
 * more segments — `[KEY, trimmedSearch, fromTime, toTime]` — so every filter
 * combination is its own cache entry; the delete hooks match on the head
 * segment alone to reach every loaded variant at once.
 */
export const DICTATION_LOGS_INFINITE_KEY = 'dictation-logs-infinite';

/** All-time dictation stats, unfiltered and deliberately un-paginated. */
export const DICTATION_LOGS_STATS_KEY = 'dictation-logs-stats';

/** "Any dictation in the trailing 7 days" probe backing the tour banner's WAU retire check. */
export const DICTATION_WAU_KEY = 'dictation-wau';
